import { DisplayMoney } from '@tock/money';
import { OfferingDetailsFeesProps } from 'components/business/offering/OfferingDetailsFees';
import { consumer } from '@tock/coretypes';
import DisplayPercentage from '@tock/shared/components/number/DisplayPercentage';
import React from 'react';

export const DisplayFees: React.FC<OfferingDetailsFeesProps> = ({ fees }) => {
  return (
    <React.Fragment>
      {fees.map((fee, index) => (
        <React.Fragment key={index}>
          <DisplayFeeValue fee={fee} /> {fee.name}
          {index < fees.length - 1 && ', '}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

const DisplayFeeValue: React.FC<{ fee: consumer.IOfferingFee }> = ({ fee }) => {
  if (fee.type === 'FLAT') {
    const feeMinAmount = fee.min;
    const feeMaxAmount = fee.max;

    return fee.min === fee.max ? (
      <DisplayMoney digitsToDisplay={0} amount={feeMinAmount} />
    ) : (
      <>
        <DisplayMoney digitsToDisplay={0} amount={feeMinAmount} />–
        <DisplayMoney digitsToDisplay={0} amount={feeMaxAmount} />
      </>
    );
  } else if (fee.type === 'PERCENT') {
    const feeMinAmount = (fee.min ?? 0) / 100;
    const feeMaxAmount = (fee.max ?? 0) / 100;

    return fee.min === fee.max ? (
      <DisplayPercentage value={feeMinAmount} />
    ) : (
      <>
        <DisplayPercentage value={feeMinAmount} />–<DisplayPercentage value={feeMaxAmount} />
      </>
    );
  }
  return null;
};
